import loadScript from 'chairisher/util/script';

import { getPinterestJSUrl } from 'chairisher/context/script';

let pinterestPromise;

/**
 * @returns {Promise}
 */
function pinterestLoader() {
    if (pinterestPromise) {
        return pinterestLoader;
    }
    pinterestPromise = loadScript({
        scriptName: 'Pinterest',
        scriptSrc: getPinterestJSUrl(),
        shouldImmediatelyResolve: true,
    });

    return pinterestPromise;
}

export default pinterestLoader;
